/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { isInt } from 'validator';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Autocomplete, Grid } from '@mui/material/';
import axios from '../../services/axios';
import { Container, Title } from '../../styles/GlobalStyles';
import Loading from '../../components/Loading';
import * as actions from '../../store/modules/auth/actions';

export default function Cadastro() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id1 } = useParams(); // id tipo despesa
  const { id2 } = useParams(); // id tipo despesa detalhe.
  const [id_tipodespesa, setIdTipoDespesa] = useState('');
  const [id_detalhe, setIdDetalhe] = useState('');

  const [tableDetalhes, setTableDetalhes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  async function getData() {
    try {
      setIsLoading(true);
      const { data } = await axios.get(`/tipodespesadetalhes/${id2}`);
      setIdTipoDespesa(data.id_tipodespesa);
      setIdDetalhe(data.id_detalhe);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(`/tipodespesadetalhes/${id1}`);
    }
  }

  async function getDataDropdown() {
    try {
      setIsLoading(true);
      const response = await axios.get('/detalhes');
      setTableDetalhes(response.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(`/tipodespesadetalhes/${id1}`);
    }
  }

  useEffect(() => {
    getDataDropdown();
    if (!id2) {
      setIdTipoDespesa(id1);
      return; // se não for alteração
    }
    getData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formErrors = false;

    if (!isInt(String(id_tipodespesa))) {
      toast.error('ID Tipo de Despesa inválido');
      formErrors = true;
    }

    if (!isInt(String(id_detalhe))) {
      toast.error('ID Tipo de Detalhe inválido');
      formErrors = true;
    }

    if (formErrors) return;

    try {
      setIsLoading(true);
      if (id2) {
        await axios.put(`/tipodespesadetalhes/${id2}`, {
          id_tipodespesa,
          id_detalhe,
        });
        toast.success('Registro alterado com sucesso!');
      } else {
        await axios.post(`/tipodespesadetalhes/`, {
          id_tipodespesa,
          id_detalhe,
        });
        toast.success('Registro cadastrado com sucesso!');
      }
      navigate(`/tipodespesadetalhes/${id1}`);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const data = get(err, 'response.data', {});
      const errors = get(data, 'errors', []);

      if (errors.length > 0) {
        errors.map((error) => toast.error(error));
      } else {
        toast.error('Erro desconhecido');
      }

      if (status === 401) dispatch(actions.loginFailure());
    }
  };

  return (
    <Container>
      <Loading isLoading={isLoading} />
      <Title>{id2 ? 'Editar Detalhe' : 'Novo Detalhe'}</Title>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12} sm={12}>
            <TextField
              value={id_tipodespesa}
              onChange={(e) => setIdTipoDespesa(e.target.value)}
              label="Tipo Despesa"
              variant="filled"
              size="small"
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              id={id_detalhe}
              value={
                tableDetalhes.find((option) => option.id === id_detalhe) || null
              }
              options={tableDetalhes}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdDetalhe(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  required
                  label="Detalhe"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              type="button"
              color="secondary"
              variant="contained"
              onClick={handleSubmit}
            >
              {id2 ? 'Alterar' : 'Cadastrar'}
            </Button>
            <Button
              type="button"
              onClick={() => navigate(`/tipodespesadetalhes/${id1}`)}
            >
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
